/**
 * Footer component.
 * @module components/theme/Footer/Footer
 */

import React from 'react';
import { injectIntl } from 'react-intl';
import { useSelector, shallowEqual } from 'react-redux';
import footerIcon from './logo_clean.svg';
import letterIcon from './envelope.svg';
import { ConditionalLink } from '@plone/volto/components';

/**
 * Component to display the footer.
 * @function Footer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component
 */
const Footer = ({ intl }) => {
  const { siteActions = [] } = useSelector(
    (state) => ({
      siteActions: state.actions?.actions?.site_actions,
    }),
    shallowEqual,
  );
  const currentLang = useSelector((state) => state.intl.locale);
  const t = {
    de: {
      copyright: "Ⓒ Carus Consilium Sachsen GmbH",
      login: "Anmelden",
      imprint: "Impressum",
      privacy: "Datenschutz",
      contact: "Kontakt",
    },
    en: {
      copyright: "Ⓒ Carus Consilium Saxony GmbH",
      login: "Login",
      imprint: "Imprint",
      privacy: "Privacy Policy",
      contact: "Contact",
    },
  };
  
  const labels = t[currentLang] || t.de; // fallback to English

  const rightDesignElem = (
    <div className='design-elem rightDesign' aria-hidden="true">
      <svg width="314.071" xmlns="http://www.w3.org/2000/svg" height="15" fill="none">
        <path d="M21.5 7.432h292.571" className="fills" />
        <g className="strokes">
          <path d="M21.5 7.432h292.571" style={{ fill: 'none', strokeWidth: 5, stroke: 'rgb(255, 255, 255)', strokeOpacity: 1, strokeDasharray: '0, 10', strokeLinecap: 'round' }} className="stroke-shape" />
        </g>
        <path d="M7.5 0C11.639 0 15 3.361 15 7.5c0 4.139-3.361 7.5-7.5 7.5A7.504 7.504 0 0 1 0 7.5C0 3.361 3.361 0 7.5 0Zm0 3A4.502 4.502 0 0 0 3 7.5C3 9.984 5.016 12 7.5 12S12 9.984 12 7.5 9.984 3 7.5 3Z" style={{ fill: 'rgb(255, 255, 255)', fillOpacity: 1 }} className="fills" />
        <g className="strokes">
          <path d="M7.5 0C11.639 0 15 3.361 15 7.5c0 4.139-3.361 7.5-7.5 7.5A7.504 7.504 0 0 1 0 7.5C0 3.361 3.361 0 7.5 0Zm0 3A4.502 4.502 0 0 0 3 7.5C3 9.984 5.016 12 7.5 12S12 9.984 12 7.5 9.984 3 7.5 3Z" style={{ fill: 'none', strokeWidth: 1, stroke: 'rgb(255, 255, 255)', strokeOpacity: 1 }} className="stroke-shape" />
        </g>
      </svg>
    </div>
  )
  //   <span className="heart-icon" style={{ backgroundImage: `url(${heartIcon})` }}></span>

  return (
      <footer className="footer">
        {rightDesignElem}

        <div className="q container layout">
          <div className="footer-container">
            <div className="logo">
              <ConditionalLink to={"/"} condition={true}>
                <span
                  style={{ backgroundImage: `url(${footerIcon})` }}
                  role="img"
                  aria-label="Carus Consilium Sachsen Logo"
                ></span>
              </ConditionalLink>
            </div>

            <div className='links'>
              <div className="first item">
                {labels.copyright}
              </div>

              <div className="first item">
                <ConditionalLink to={"/login"} condition={true}>
                  {labels.login}
                </ConditionalLink>
              </div>

              <div className="first item">
                <ConditionalLink to={`/de/impressum`} condition={true}>
                  {labels.imprint}
                </ConditionalLink>
              </div>

              <div className="first item">
                <ConditionalLink to={`/de/datenschutz`} condition={true}>
                  {labels.privacy}
                </ConditionalLink>
              </div>

              <div className="first item">
                <ConditionalLink to={`/${currentLang}/${String(labels.contact).toLowerCase()}`} condition={true}>
                  <div className='icon small'>
                    <span
                      style={{ backgroundImage: `url(${letterIcon})` }}
                      role="img"
                      aria-label={labels.contact}>
                    </span>
                  </div>
                </ConditionalLink>
              </div>
            </div>
          </div>
        </div>
      </footer>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
        * @static
        */
Footer.propTypes = {
  /**
   * i18n object
   */
};

export default injectIntl(Footer);
